import axiosInstance from "../axiosInstance";
import { endpoints } from "../endpoints";

export const FetchSubmitedVideos = async (datas) => {
  function buildQueryString() {
    const queryParts = [];
    // console.warn("datas", datas);
    for (const key in datas) {
      // console.warn("key", key);
      if (
        key !== "null" &&
        datas.hasOwnProperty(key) &&
        datas[key] !== null &&
        datas[key] !== undefined &&
        datas[key] !== ""
      ) {
        const value = encodeURIComponent(datas[key]);
        queryParts.push(`${key}=${value}`);
      }
    }

    return queryParts.join("&");
  }

  try {
    // console.warn("call-----------------------------------------------------------------------------------------------");
    let queryString = buildQueryString();
    // console.warn("queryString-------------", queryString);

    const res = await axiosInstance.get(
      `${endpoints.videos.videos}?${queryString}`
    );
    return res;
  } catch (error) {
    return error;
  }
};

//
